//@flow
import FunctionStore from '../Base/functionStoreClass';
import { updateState, getFlagProp, setFlagProp } from '../Base/storeUtils';
import Constants from '../../constants';
import ChatActions from '../../Actions/chat';
import CookiesData from '../../Utils/cookies-data';
import UrlData from '../../Utils/url-data';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';

let _setupPending:boolean = false;

type Department = {
  id:number,
  name:string,
  status:string,
};

export default class ChatStore extends FunctionStore {
  isChatOnline():boolean {
    if (!_setupPending) {
      _setupPending = true;
      _tryTo(_setupChat.bind(this));
    }
    return this.getState().get('status') === 'online';
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.SET_CHAT_STATUS, updateState(_setStatus));
    onSuccess(Constants.OPEN_CHAT, _openChat);
  }
}

function _closeChat() {
  CookiesData.remove('chat');
  _getChat()('webWidget', 'hide');
}

function _filterDepartments(state:StoreState) {
  if (getFlagProp(state, 'filteredDepartments')) return;

  // find the right department and remove the dropdown
  const dept = _getDepartment();
  if (dept) {
    const settings = _getChatSettings();
    settings.webWidget.chat.departments.select = dept.id;
    settings.webWidget.chat.departments.enabled = [];
    setFlagProp(state, 'filteredDepartments', true);
  }
}

function _getChat() {
  return window.zE;
}

function _getChatSettings() {
  return window.zESettings;
}

function _getDepartment():?Department {
  const departments:Array<Department> = _getChat()('webWidget:get', 'chat:departments');
  let departmentName:RegExp = /naturebox/i;
  if (UrlData.onCorporatePage()) {
    departmentName = /Office Snacking/i;
  }
  return departments.find((dept) => dept.name.search(departmentName) > -1);
}
/*
 * open the chat window and track the fact it was opened in a cookie
 */
function _openChat() {
  CookiesData.set('chat', 'open');
  // New zendesk api doesn't open the chat by default
  window.$zopim && window.$zopim.livechat.window.show();
}

/*
 * There are three status; undefined, online or offline.
 * 'undefined' means that we have not checked the widget status
 * via zopim api or the zopim widget is not available
 */
function _setStatus(state:StoreState, status:string) {
  const dept:?Department = _getDepartment();
  let newStatus = status;

  // if we have a department and the general status is online, try and make
  // the status specific to the membership department
  if (newStatus === 'online' && dept) {
    newStatus = dept.status;

    // we do the filtering here because sometimes the department list is empty
    // but we seem to get status callbacks until the departments are filled in
    _filterDepartments(state);
  }

  if (newStatus === 'online' && CookiesData.getBool('chat')) {
    _openChat();
  }

  state.set('status', newStatus);
}

function _setupChat() {
  // setup general chat callbacks and hidden state
  const chat = _getChat();
  chat('webWidget', 'hide');
  chat('webWidget:on', 'close', _closeChat);
  chat('webWidget:on', 'chat:status', ChatActions.setStatus);
}

function _tryTo(callback:()=>void) {
  try {
    if (_getChat()) {
      callback();
      return;
    }
  } catch (e) {
    //$zopim.livechat not available yet
  }

  setTimeout(_tryTo.bind(null, callback), 200);
}
